function distinctBy<T, K extends keyof T>(arr: T[] = [], accessorKey: K) {
  const result = arr.reduce(
    (acc, curr) => {
      const currKey = curr?.[accessorKey] as unknown as string;
      acc[currKey] = curr;
      return acc;
    },
    {} as Record<string, T>
  );

  return Object.values(result);
}

export { distinctBy };
